// kagitUcusSil.js — KÂĞIT OFP UÇUŞUNU SİL: TEK KOMUT, TEK KAYNAK (5 Eki 2026)
//
// 🔑 Serkan (5 Eki 2026): *"o uçuş iki pilottan da silinse daha kolay olur mu — link vermek yerine emir versek; bu uçuş
//    sistemden ekleri ile çıkacak ve pilotlardan silinecek, saat kayıtları motor uçak dahi alınacak"* · *"evet tamam
//    silinsin"* · *"mantıklı, karışıklık olmaz, tekrar girilir gerekirse"*.
// Bir komut, sırasıyla (iz HER ZAMAN önce — silme/iptal/edit ile aynı ilke):
//   1) bütün ekibin görevleri CANCELLED → FTL'den düşer (görev, uçuş süresi, toplamlar; sunucu yeniden hesaplar)
//   2) kâğıt kaydın BÜTÜN bacakları geçersiz (deleted_at + gerekçe) → STATISTICS, pilot süzgeci, uçak/motor saati
//      okumaz; kayıt KALICI SİLİNMEZ — ARCHIVED FLTS'te DELETED rozetiyle durur (denetim izi, hard delete yok)
//   3) ekli PDF'ler silinir (tek tek REMOVE ile aynı yol `kagitEvrakKaldir`; adları izde kalır)
// Her yazma DÖNEN SATIRLA doğrulanır (RLS reddi hata değil 0 satır döner — İlke 2); ilk düşende durulur, ne olduğu ve
// ne olmadığı ADIYLA döner.
import { supabase } from '../supabaseClient';
import { kagitEvraklari, kagitEvrakKaldir, mbYaz } from './kagitEvrak';
import { kagitAnahtari } from './kagitUcus';
import { gerekceTamam, gerekceIpucuMetni } from './gerekceKurali';

/** İzde geçersiz kılınan kâğıt kaydın yeni değeri — üç yol aynı cümle. */
export const KAGIT_GECERSIZ_IZ = 'DELETED (record retained, not counted)';

/** Kâğıt kaydın izdeki adı: "PAPER OFP TC-REC — LTBA-LTAC · LTAC-LTFE" (DELETE FLIGHT, CANCEL, işaret kaldırma aynı biçim). */
export function kagitOzeti(bacaklar) {
  const b = (bacaklar || []).slice().sort((x, y) => (x.seq ?? 0) - (y.seq ?? 0));
  return `PAPER OFP ${b[0]?.reg || '(no reg)'} — ${b.map(x => `${x.dep}-${x.dest}`).join(' · ')}`;
}

/** Kâğıt kaydın CANLI bacakları — geçersiz kılmadan ÖNCE okunur (iz ve doğrulama için).
 *  @returns {Promise<{ bacaklar: object[], hata?: string }>} */
export async function kagitCanliBacaklari(anahtar) {
  if (!anahtar) return { bacaklar: [] };
  const { data, error } = await supabase.from('manual_flights').select('id,customer_id,seq,dep,dest,reg')
    .eq('assignment_id', anahtar).is('deleted_at', null);
  return error ? { bacaklar: [], hata: error.message } : { bacaklar: data || [] };
}

/** KÂĞIT KAYDI GEÇERSİZ KIL — TEK YER (5 Eki 2026, Serkan A: iptal ya da PAPER OFP işareti kaldırılınca kayıt silinmez,
 *  gerekçeyle DELETED olur → STATISTICS + uçak/motor saatinden düşer, ARCHIVED FLTS'te rozetle durur; işaret geri konunca
 *  yazıcı `paperOfpYaz` satırı geri açar). Evrak burada SİLİNMEZ (yalnız DELETE FLIGHT siler).
 *  `beklenen`: önceden okunan canlı bacak sayısı — dönen satır sayısı tutmazsa (RLS reddi 0 satır döner, İlke 2) hata.
 *  @returns {Promise<{ bacak: number, hata?: string }>} */
export async function kagitKaydiGecersizKil({ anahtar, neden, kullaniciId = null, beklenen }) {
  if (!anahtar || !beklenen) return { bacak: 0 };
  const { data, error } = await supabase.from('manual_flights')
    .update({ deleted_at: new Date().toISOString(), deleted_by: kullaniciId, delete_reason: neden })
    .eq('assignment_id', anahtar).is('deleted_at', null).select('id');
  const bacak = (data || []).length;
  if (error || bacak !== beklenen) return { bacak, hata: error?.message || 'no row returned (permission?)' };
  return { bacak };
}

/** Verilen uçuş anahtarlarından CANLI (geçersiz kılınmamış) kâğıt kaydı olanlar — DUTY HISTORY rozeti (5 Eki 2026).
 *  200'lük dilimler (URL sınırı; satır tavanına da takılmaz). Okunamazsa `anahtarlar: null` — bilinmiyor ≠ yok.
 *  @returns {Promise<{ anahtarlar: Set<string>|null, hata?: string }>} */
export async function canliKagitAnahtarlari(anahtarlar) {
  const liste = [...new Set((anahtarlar || []).filter(Boolean))];
  const out = new Set();
  for (let i = 0; i < liste.length; i += 200) {
    const { data, error } = await supabase.from('manual_flights').select('assignment_id')
      .in('assignment_id', liste.slice(i, i + 200)).is('deleted_at', null);
    if (error) return { anahtarlar: null, hata: error.message };
    (data || []).forEach(x => out.add(x.assignment_id));
  }
  return { anahtarlar: out };
}

/** DUTY ROSTER CANCEL'ın kâğıt kayda etkisi (5 Eki 2026, Serkan A + "başla"): kâğıt kayıt YALNIZ iptalden sonra o uçuşun
 *  ekibinde görevi canlı kimse kalmıyorsa geçersiz olur. Ekipten bir pilot iptal edilip uçuş ötekilerle uçulmuş
 *  görünüyorsa kayıt KALIR (uçuş oldu). Pencere bunu önceden söyler; kaydet anında TAZE okunur.
 *  @param satirlar iptal edilecek görev satırları
 *  @returns {Promise<{ etki: { anahtar, bacaklar, ilk }[], hata?: string }>} */
export async function kagitIptalEtkisi(satirlar) {
  const iptal = new Set((satirlar || []).map(r => r.id));
  const etki = [];
  for (const anahtar of [...new Set((satirlar || []).map(kagitAnahtari).filter(Boolean))]) {
    const ilk = satirlar.find(r => kagitAnahtari(r) === anahtar);
    const { bacaklar, hata } = await kagitCanliBacaklari(anahtar);
    if (hata) return { etki: [], hata };
    if (!bacaklar.length) continue;
    let ekip = [ilk];
    if (ilk.assignment_id) {
      const { data, error } = await supabase.from('crew_duties').select('id,status').eq('assignment_id', anahtar);
      if (error) return { etki: [], hata: error.message };
      ekip = data || [];
    }
    if (ekip.some(g => g.status !== 'cancelled' && !iptal.has(g.id))) continue;   // uçuş ekibin kalanıyla uçuldu
    etki.push({ anahtar, bacaklar, ilk });
  }
  return { etki };
}

/** İkinci uyarı ekranı için (Serkan 5 Eki 2026: *"FTL kayıtları da silinecek — ikinci soru ekranı, warning vererek"*):
 *  iptal edilecek canlı ekip görevleri. @returns {Promise<{ gorevler: object[], hata?: string }>} */
export async function kagitUcusEtkisi(anahtar) {
  if (!anahtar) return { gorevler: [] };
  let { data, error } = await supabase.from('crew_duties').select('id,pilot_id,status,duty_date').eq('assignment_id', anahtar);
  if (!error && !(data || []).length) {
    ({ data, error } = await supabase.from('crew_duties').select('id,pilot_id,status,duty_date').eq('id', anahtar));
  }
  if (error) return { gorevler: [], hata: `The crew duties of this flight could not be read — ${error.message}` };
  return { gorevler: (data || []).filter(g => g.status !== 'cancelled') };
}

/** @param anahtar kâğıt kaydın anahtarı (`kagitAnahtari`: atama ya da görev kimliği)
 *  @returns {Promise<{ tamam: boolean, hata?: string, kismen?: boolean, iptal: number, bacak: number, evrak: number }>} */
export async function kagitUcusuSil({ anahtar, gerekce, kullaniciId = null }) {
  const sonuc = { tamam: false, iptal: 0, bacak: 0, evrak: 0 };
  const neden = String(gerekce || '').trim();
  if (!anahtar) return { ...sonuc, hata: 'No flight key — nothing was deleted.' };
  if (!gerekceTamam(neden)) return { ...sonuc, hata: gerekceIpucuMetni(neden) };   // ortak kural (21 Eki 2026, K7)
  const why = `Paper OFP flight deleted (ARCHIVED FLTS): ${neden}`;

  // ── 0) OKU — ekip (bütün durumlar: iz kimliği için), kâğıt bacaklar, evrak ──
  let { data: gorevler, error: gErr } = await supabase.from('crew_duties')
    .select('id,customer_id,pilot_id,assignment_id,status').eq('assignment_id', anahtar);
  if (!gErr && !(gorevler || []).length) {
    ({ data: gorevler, error: gErr } = await supabase.from('crew_duties')
      .select('id,customer_id,pilot_id,assignment_id,status').eq('id', anahtar));
  }
  const [{ data: bacaklar, error: bErr }, { data: evraklar, error: eErr }] = await Promise.all([
    supabase.from('manual_flights').select('id,customer_id,seq,dep,dest,reg')
      .eq('assignment_id', anahtar).is('deleted_at', null),
    kagitEvraklari(anahtar),
  ]);
  const okumaHatasi = gErr || bErr || eErr;
  if (okumaHatasi) return { ...sonuc, hata: `The flight could not be read — ${okumaHatasi.message}. Nothing was deleted.` };
  const tumGorev = gorevler || [];
  const canli = tumGorev.filter(g => g.status !== 'cancelled');
  const ilk = tumGorev[0];
  if (!ilk) return { ...sonuc, hata: 'No crew duty found for this flight — nothing was deleted.' };

  // ── 1) İZ ÖNCE ──
  const iz = (g, alan, eski, yeni, tur = 'EDIT') => ({
    duty_id: g.id, customer_id: g.customer_id, pilot_id: g.pilot_id, assignment_id: g.assignment_id || null,
    edit_type: tur, field_name: alan, old_value: eski, new_value: yeni, reason: why, edited_by: kullaniciId,
  });
  const izler = [
    ...canli.map(g => iz(g, 'status', g.status, 'cancelled', 'CANCEL')),
    ...((bacaklar || []).length ? [iz(ilk, 'paper_ofp', kagitOzeti(bacaklar), KAGIT_GECERSIZ_IZ)] : []),
    ...(evraklar || []).map(d => iz(ilk, 'paper_ofp_document', `${d.file_name} (${mbYaz(d.file_size)})`, 'REMOVED — file deleted')),
  ];
  const { error: izErr } = await supabase.from('ftl_duty_edits').insert(izler);
  if (izErr) return { ...sonuc, hata: `Audit write failed — ${izErr.message}. Nothing was deleted.` };

  // ── 2) EKİP GÖREVLERİ İPTAL ──
  if (canli.length) {
    const { data: iptalEdilen, error } = await supabase.from('crew_duties')
      .update({ status: 'cancelled' }).in('id', canli.map(g => g.id)).select('id');
    if (error || (iptalEdilen || []).length !== canli.length) {
      return { ...sonuc, iptal: (iptalEdilen || []).length, kismen: (iptalEdilen || []).length > 0,
               hata: `The crew duties were not all cancelled — ${error?.message || 'no row returned (permission?)'}. `
                   + 'The paper record and its documents were NOT touched.' };
    }
    sonuc.iptal = canli.length;
  }

  // ── 3) KÂĞIT KAYIT GEÇERSİZ (silinmez) ──
  if ((bacaklar || []).length) {
    const g = await kagitKaydiGecersizKil({ anahtar, neden: why, kullaniciId, beklenen: bacaklar.length });
    if (g.hata) {
      return { ...sonuc, kismen: true,
               hata: `Crew duties cancelled, but the paper record was not marked deleted — ${g.hata}. `
                   + 'It is still counted in statistics and aircraft hours.' };
    }
    sonuc.bacak = g.bacak;
  }

  // ── 4) EVRAK SİLİNİR ──
  for (const d of evraklar || []) {
    const { hata } = await kagitEvrakKaldir(d);
    if (hata) return { ...sonuc, kismen: true, hata: `Flight deleted, but a document was not: ${hata}` };
    sonuc.evrak += 1;
  }
  return { ...sonuc, tamam: true };
}
